<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-table :task="getList" :entity="entity" :actions="actions" :filter-entity="filterEntity" />
</template>
<script>
	import { ProductGroup, ProductGroupFilter } from '@/modules/store/data/product-group/list'
	import { ProductGroupService } from '@/modules/store/services'
	export default {
		computed:
		{
			entity()
			{
				return ProductGroup;
			},
			
			filterEntity()
			{
				return ProductGroupFilter;
			},

			service()
			{
				return new ProductGroupService();
			},

			actions()
			{
				return [
					{
						routeName: 'store.productGroup.create',
						resourceKey: 'action.create',
						iconName: 'bi-plus-circle',
						activeMode: 'always',
					},
					{
						routeName: 'store.productGroup.createImport',
						resourceKey: 'action.import',
						iconName: 'bi-upload',
						activeMode: 'always',
					},
					{
						routeName: 'store.productGroup.attachment',
						resourceKey: 'action.fileAttachment',
						iconName: 'bi-cloud-arrow-up',
						activeMode: 'single',
						dataTransferMode: 'store',
					},
					{
						routeName: 'store.productGroup.imageAttachment',
						resourceKey: 'action.imageAttachment',
						iconName: 'bi-images',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						routeName: 'store.productGroup.update',
						resourceKey: 'action.update',
						iconName: 'bi-pen',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						routeName: 'store.productGroup.delete',
						resourceKey: 'action.delete',
						iconName: 'bi-trash',
						activeMode: 'multiple',
						dataTransferMode: 'store',
					},
					{
						resourceKey: 'action.more',
						iconName: 'bi-arrow-down-short',
						activeMode: 'single',
						children: [
							{
								routeName: 'store.productGroup.list',
								resourceKey: 'store.productGroupList',
								iconName: 'bi-list-columns',
								activeMode: 'single',
								dataTransferMode: 'query',
								dataTransferKeys: ['productGroupId'],
							},
							{
								routeName: 'store.product.list',
								resourceKey: 'store.productList',
								iconName: 'bi-list-columns',
								activeMode: 'single',
								dataTransferMode: 'query',
								dataTransferKeys: ['productGroupId'],
							},

						]
					},

				]
			}
		},
		methods:
		{
			async getList(payload)
			{
				return await this.service.list(payload);
			}
		}
	}
</script>